import { API_BASE_URL } from '../config/apiConfig';

/**
 * The waiting-room TV talks to ONE read-only endpoint with a display token. It deliberately does not use the staff API client: that client
 * sends staff credentials and, on a 401, signs the user out and sends them to the login page, which a TV must never do.
 */
export const queueDisplayService = {
  /**
   * Resolves { ok: true, data } for a board, { unauthorised: true } when the token was revoked, expired or never valid, and rejects on a
   * network problem or a server error so the screen can say "connection lost" and keep trying.
   */
  board: async (token) => {
    const response = await fetch(`${API_BASE_URL}/queue-display/board`, {
      headers: { 'X-Display-Token': token, Accept: 'application/json' },
      cache: 'no-store',
      credentials: 'omit',
    });
    if (response.status === 401) return { unauthorised: true };
    if (!response.ok) throw new Error(`Board request failed (${response.status})`);
    const body = await response.json();
    return { ok: !!body.success, data: body.data, message: body.message };
  },
};

export default queueDisplayService;
